/*! nosto-shopify-snippet
 *  License: Copyright (c) 2024 Nosto Solutions Ltd. All Rights Reserved.
 */
import { sendCartTokenFromShopifyCookie } from "./script-tag"
import marketsPreviewOverlay from "./markets-preview-overlay"
import initStub from "./stub"
import initCartScript from "./cart-script"
import { updateAnalyticsTagging } from "./tagging"

if (!window.Nosto?.shopifyScript) {
  initStub()
  updateAnalyticsTagging()
  initCartScript()
  sendCartTokenFromShopifyCookie()
  marketsPreviewOverlay()
} else {
  console.log("Nosto Shopify script already initialized")
}
